export const LOAD_TEMPLATE_DETAIL =
  'editorAC/TemplatePreview/LOAD_TEMPLATE_DETAIL';
export const LOAD_TEMPLATE_DETAIL_SUCCESS =
  'editorAC/TemplatePreview/LOAD_TEMPLATE_DETAIL/SUCCESS';
export const LOAD_TEMPLATE_DETAIL_ERROR =
  'editorAC/TemplatePreview/LOAD_TEMPLATE_DETAIL/ERROR';

export const LOAD_SIMILAR_TEMPLATES =
  'editorAC/TemplatePreview/LOAD_SIMILAR_TEMPLATES';
export const LOAD_SIMILAR_TEMPLATES_SUCCESS =
  'editorAC/TemplatePreview/LOAD_SIMILAR_TEMPLATES/SUCCESS';
export const LOAD_SIMILAR_TEMPLATES_ERROR =
  'editorAC/TemplatePreview/LOAD_SIMILAR_TEMPLATES/ERROR';